import { useElementSize } from '@vueuse/core'
import useWidgetOptions from '../widget-options/useWidgetOptions'
import useEmbed from '@/embed/code'
import { computed, onBeforeMount, onUnmounted, ref, watch, type Ref } from 'vue'

const { setIframeHeight } = useEmbed()
const { options: widgetOptions } = useWidgetOptions()
const pauseAutoHeight = ref(false)

export default function useWidgetAutoHeight() {
    const appAutoHeight = computed(() => {
        const { inline, autoHeight } = widgetOptions.value
        return inline && autoHeight
    })

    const appAutoHeightOn = computed(() => {
        return appAutoHeight.value && !pauseAutoHeight.value
    })

    const runAppAutoHeight = (resizeRef: Ref<HTMLElement | undefined>) => {
        const size = useElementSize(resizeRef)

        watch(
            () => size,
            s => {
                if (widgetOptions.value?.inline && !pauseAutoHeight.value) {
                    setIframeHeight(`${s.height.value}px`)
                }
            },
            { deep: true },
        )
    }

    const setIntegrationFixedHeightInAppAutoHeight = (min = '600px') => {
        onBeforeMount(() => {
            if (appAutoHeight.value) {
                setIframeHeight(`min(${min}, 90vh)`)
                pauseAutoHeight.value = true
            }
        })

        onUnmounted(() => {
            pauseAutoHeight.value = false
        })
    }

    return {
        appAutoHeightOn,
        runAppAutoHeight,
        setIntegrationFixedHeightInAppAutoHeight,
    }
}
